/**
 * Welcher Reiter im Menü gilt als „hier"? (23.09.2026, Ticket 2542)
 *
 * Martin: „Wenn er in den Einstellungen ist und dann zurückgeht oder über
 * das Menü auf ‚Chat' tippt, öffnet sich der Chat-Tab nicht."
 *
 * Nachgestellt (Playwright, 393 × 852): Einstellungen öffnen, Pfeil zurück,
 * im Menü auf die Sprechblase tippen → nichts, die Einstellungen bleiben.
 * Der Knopf trug `aria-current="page"` und war gesperrt.
 *
 * ⚠️ Zwei Regeln, jede für sich richtig, zusammen falsch:
 *    1. updateNavActive (21.07.) markierte „Chat als Standard", sobald kein
 *       Reiter ausgewählt war — und in den Einstellungen ist nie einer
 *       ausgewählt, sie haben keinen eigenen.
 *    2. Die Symbolleiste unten (22.09.) sperrt den Knopf der Seite, auf der
 *       man steht („NIE ein Knopf, der dorthin führt, wo man schon steht").
 *    Ergebnis: in den Einstellungen galt Chat als „hier" und war gesperrt.
 *
 * Jetzt gilt als „hier" nur, was wirklich offen ist.
 */
export function markiereReiter(
  reiter: readonly HTMLElement[],
  /** Steht gerade eine Vollseite über dem Hash offen (Alltag, Spiegel …)? */
  vollseiteOffen: boolean,
  /** Die sichtbare Ansicht (body.dataset.activeView), z. B. „settings". */
  offen: string | undefined,
): void {
  for (const r of reiter) {
    const hier = !vollseiteOffen && !!offen && r.dataset.tab === offen;
    r.setAttribute("aria-selected", hier ? "true" : "false");
  }
}
